import type { GradeActionsType } from "../actions/GradeActions";
import { SET_GRADE } from "../actions/GradeActions";
import type { GradeType } from "../../../../../common-deprecated/types/GradeType";

export const initialState: GradeType = {
    id: "",
    name: "",
    colourCode: "",
    availableForOnlineSales: false,
    availableForOnlineReservation: false,
    availableForOnlineLeasing: false,
    subtitle: "",
    bodyType: { id: "", name: "" },
    model: { id: "", name: "", code: "", defaultCCISBackground: "", labels: [] },
    description: "",
    mainFeatureEquipment: [],
    listFeatureEquipment: [],
    defaultCarId: "",
    motorizations: [],
    tyresCodes: [],
    filterItems: [],
};

const gradeReducer = (state: GradeType = initialState, action: GradeActionsType): GradeType => {
    switch (action.type) {
        case SET_GRADE:
            return action.grade;

        default:
            return state;
    }
};

export default gradeReducer;
